module.exports = __webpack_public_path__ + "img/Compare.f00e0e67.svg";